import clsx, { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Compose conditional class names; later Tailwind utilities override earlier conflicting ones. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
